/**
 * This is the global store of code-page application. Any shared state that will be used across different component in the tree
 * should be located in this file. But DO NOT ABUSE IT. Please carefully think when you extend this global store.
 */

import { type Action, createStore, createHook } from 'react-sweet-state';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types';
import { toProjectKey, toProjectUuid } from '@atlassian/jira-shared-types';
import { setProjectContext, setShowingAllRepositories } from './actions';
import type { State } from './types';

const resetState =
	(): Action<State> =>
	({ setState }) => {
		setState(initialState);
	};

export const actions = {
	setProjectContext,
	setShowingAllRepositories,
	resetState,
} as const;

export type Actions = typeof actions;

// @ExportForTesting
export const initialState: State = {
	// We have to provide a dummy projectContext as initial state, because Flow would complain otherwise.
	// @ts-expect-error - TS2741 - Property 'isProjectAdmin' is missing in type '{ projectKey: string; projectId: number; projectUuid: string; projectName: string; simplified: false; projectType: "software"; }' but required in type 'ProjectContext'.
	projectContext: {
		projectKey: toProjectKey(''),
		projectId: -1,
		projectUuid: toProjectUuid('invalid'),
		projectName: '',
		simplified: false,
		projectType: SOFTWARE_PROJECT,
	},
	showingAllRepositories: false,
};

// @ExportForTesting
export const Store = createStore<State, Actions>({
	name: 'codePageGlobalStore',
	initialState,
	actions,
});

export const useCodeLocalStore = createHook(Store);
